import React from "react";
import { NavLink } from "react-router-dom";

const Header = () => {
  return (
    <div className="header">
      <nav>
        <NavLink to="/">
          <h1>CinéFilms</h1>
        </NavLink>
      </nav>

      <nav>
        <ul>
          <NavLink to="/" className={(nav) => (nav.isActive ? "nav-active" : "")}>
            <li>Accueil</li>
          </NavLink>
          <NavLink to="coups-de-coeur" className={(nav) => (nav.isActive ? "nav-active" : "")}>
            <li>Favoris</li>
          </NavLink>
        </ul>
      </nav>
    </div>
  );
};

export default Header;
